import http from "./AxiosInstance";

class BilanCommandeService {
  // 1. Bilan général des commandes
  async getBilanGeneral(periode) {
    const response = await http.get(`/bilan-commande/general/${periode}`)
    return response
  }

  // 2. Évolution des commandes
  async getEvolution(type) {
    const response = await http.get(`/bilan-commande/evolution/${type}`)
    return response
  }

  // 3. Analyse des fournisseurs
  async getAnalyseFournisseurs() {
    const response = await http.get(`/bilan-commande/fournisseurs/analyse`)
    return response
  }

  // 4. Analyse des produits
  async getAnalyseProduits() {
    const response = await http.get(`/bilan-commande/produits/analyse`)
    return response
  }

  // 5. Comparaison commandes vs livraisons
  async getCommandesVsLivraisons() {
    const response = await http.get(`/bilan-commande/commandes-vs-livraisons`)
    return response
  }

  // 6. Alertes
  async getAlertes() {
    const response = await http.get(`/bilan-commande/alertes`)
    return response
  }

  // 7. Détail par date
  async getDetailParDate(dateDebut, dateFin) {
    const response = await http.get(`/bilan-commande/detail/${dateDebut}/${dateFin}`)
    return response
  }

  // 8. Synthèse
  async getSynthese() {
    const response = await http.get(`/bilan-commande/synthese`)
    return response
  }
}

const bilanCommandeService = new BilanCommandeService();
export default bilanCommandeService;